
/* Form elements
**********************************************************************/

jQuery(document).ready(function($) {
	
	$('form .field-wrapper :input')
		.on('keyup', function() {
			var field = $(this).parents('.field-wrapper');
			if ($(this).val() == '')
				field.removeClass('show-label');
			else
				field.addClass('show-label');
		});
		
	
});
	